<template>
  <div>
    <div style="width: 98%;">
      <div class="search-wrap">
        <el-button size="mini" type="primary text2" @click="search">搜索</el-button>
        <el-button size="mini" type="primary text2" v-if="ERP.isPermission(3004012001)" @click="exportExcel">导出</el-button>
        <el-button size="mini" type="primary text2" v-if="ERP.isPermission(3004012002)" @click="importExcel">导入</el-button>
        <el-descriptions :column="1" border>
          <el-descriptions-item size="mini" label="房产">
            <el-input size="mini" placeholder="请输入搜关键字" v-model="where.address" clearable style="width: 380px"></el-input>
          </el-descriptions-item>
          <el-descriptions-item size="mini" label="房产类型">
            <el-checkbox-group size="mini" v-model="where.house_type" style="width: 100%;" @change="search()">
              <el-checkbox label="1">住宅</el-checkbox>
              <el-checkbox label="4">商铺</el-checkbox>
              <el-checkbox label="5">写字楼</el-checkbox>
              <el-checkbox label="2">车位</el-checkbox>
              <el-checkbox label="3">储藏室</el-checkbox>
            </el-checkbox-group>
          </el-descriptions-item>
        </el-descriptions>
        <!--          <el-button size="mini" type="primary" @click="editUser()" style="margin-right: 5px;" icon="el-icon-plus">添加</el-button>-->


<!--        <el-select size="mini" v-model="where.room_status_ids" placeholder="房态" @change="search()">-->
<!--          <el-option-->
<!--            v-for="(item,index) in room_status_list_2"-->
<!--            :key="index"-->
<!--            :value="item.id" :label="item.name">-->
<!--            <span style="float: left">{{ item.name }}</span>-->
<!--            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.count }}</span>-->
<!--          </el-option>-->
<!--        </el-select>-->
      </div>
      <HeaderTip>
        空置房数量：{{ pageData.total }}
      </HeaderTip>
      <div class="table-wrap">
        <el-table v-if="pageData" v-loading="loading" :data="pageData.list" height="70vh" border>
<!--          <el-table-column prop="community_name" label="项目名称" width="180" align="center" ></el-table-column>-->
          <el-table-column prop="address" label="房产" align="left" min-width="320"></el-table-column>
          <el-table-column prop="customer_name" label="业主名称" width="300" align="center" >
            <template slot-scope="scope">
              <div v-if="scope.row.customer_id">
                <el-link type="primary" @click="openCustomer(scope.row)">{{ scope.row.customer_name }}</el-link>
                （<span style="color: #8492a6; font-size: 13px">{{ scope.row.customer_id }}</span>）
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="room_status_name" label="ERP房态" align="center" width="80"></el-table-column>
          <el-table-column label="操作" width="120" align="center" fixed="right">
            <template slot="default" slot-scope="scope">
<!--              <el-button v-if="ERP.isPermission(3004012003)" @click="editRoomStatus(scope.row)">修改房态</el-button>-->
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination-wrap">
        <el-pagination background layout="prev, pager, next" :total="pageData.total*1" :page-size="pageData.pageSize*1" :current-page="pageData.page*1" @current-change="pageChange"></el-pagination>
      </div>
    </div>

    <editor v-model="customerObj.isOpen" :id="customerObj.id" :is_edit="customerObj.is_edit" :class-value="customerObj.classValue" @close="customerObj.isOpen=false" />
  </div>
</template>

<script>
import CommonHelp from "../../common/CommonHelp";
import SearchHouse from "../../../Common/search-house";
import Editor from "../../../Customer/editor";
import HeaderTip from "../../../Common/header-tip";

export default {
  name: "EmptyRoomList",
  components: {
    HeaderTip,
    Editor,
    SearchHouse
  },
  inject: ['mainObj'],
  data() {
    return {
      loading: false,
      where:{
        room_status_ids:1,
        address:"",
        house_type:['1','4','5'],
      },
      pageData:{
        list:[],
        total:0,
        pageSize:15,
        page:1
      },
      form:{
        remarks:""
      },
      room_status_list_2:[],
      dialogVisible:false,
      customerObj:{isOpen:false,id:0,classValue:0,is_edit:false}
    }
  },
  mounted() {
    this.where.address=this.mainObj.house_name;
    this.search()
    this.getStatistics()
  },
  methods:{
    openCustomer(row){
      this.customerObj.isOpen=true;
      this.customerObj.id=row.customer_id;
      this.customerObj.classValue=row.class_value;
      this.customerObj.is_edit=false;
    },
    search() {
      this.pageData.page = 1
      this.getList()
    },
    nodeClick(data){
      this.where.address=data.tree.map(ret => {
        return ret.name
      }).join('->');
      this.search()
      this.getStatistics()
    },
    getList() {
      const that = this;
      let where=CommonHelp.reObject(this.where);
      if(where.address){
        that.loading=true;
        ERP.getRequest({url:"admin/RoomStatus/getList",data:{
            where:JSON.stringify(where),
            page: this.pageData.page,
            page_size: this.pageData.pageSize
          }
        },res=>{
          if(res.code) {
            that.pageData=res.data
          }
          that.loading=false;
        })
      }
    },
    getStatistics() {
      const that = this;
      let where=CommonHelp.reObject(this.where);
      if(where.address){
        ERP.getRequest({url:"admin/RoomStatus/getStatistics",data:{
            where:JSON.stringify(where)
          }
        },res=>{
          if(res.code) {
            that.room_status_list_2=res.data
          }
        })
      }
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    exportExcel(){
      const that = this;
      let where=CommonHelp.reObject(that.where);
      if(!where.address){
        that.$message.error('选择项目房产或输入')
        return false;
      }

      that.$confirm(`您确定导出的房态列表是 【${where.address}】 ？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = {
          targetController:"RoomStatusTask",
          targetFunction:"exportExcelTask",
          taskName:"房态导出",
          where:JSON.stringify(where),
        };

        ERP.postRequest({url:"admin/ExcelTask/addTask",data},ret=>{
          if(ret.code===200){
            that.$message.success("报表生成中……");
          }else {
            that.$message.error("数据拉取失败");
          }
        },err=>{
          that.$message.error("数据请求异常");
        })


      }).catch(() => {
      });
    },
    importExcel(){
      const that = this;
      that.$confirm('您将操作导入房态，下一步将启动选择文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.loading=true;
        CommonHelp.uploadFile(ret=>{
          console.log(ret);
          ERP.postRequest({url:"admin/RoomStatus/importExcel",data:{
              file:ret
            }
          },res=>{
            if(res.code) {
              that.$message.success(res.msg||'导入成功');
              that.getStatistics()
              that.getList();
            }else {
              this.$message.error(res.msg||'导入失败');
            }
            that.loading=false;
          })
        });
      }).catch(() => {

      });

    }
  },
  watch:{
    "mainObj.house_name":function(val){
      this.where.address=val;
      this.search()
      this.getStatistics()
    }
  }
}
</script>

<style lang="scss" scoped>
.el-button--primary,.el-button--success,.el-button--danger,.el-button--warning {
  color: #FFF;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.pagination-wrap{
  margin-top: 20px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/HouseCode/components/room-status/EmptyRoomList.vue